import api from 'axios'

export default {
  getProductById: async (ids) => {
    const idParams = Array.isArray(ids) ? ids.join(',') : ids
    return (await api.get(`/v1/discover/web/products?product_id=${idParams}`))
      .data[0]
  },

  // getRecommendedProductsById: async () =>
  //   (
  //     await api(
  //       '/discover/recommend/v1/products/0019b633-4a09-4a31-8e28-35076d01566f?limit=10&offset=0',
  //       {
  //         customer_id: 'cust_lumOXbnQ8EgVpeNWUJFaN1',
  //       },
  //     )
  //   ).data.products,

  getMerchantProductsById: async (id, count) => (
    await api.get(
      `/v1/discover/web/merchant/${id}/products?limit=${count}&offset=0`,
      {
        customer_id: 'cust_lumOXbnQ8EgVpeNWUJFaN1',
      },
    )
  ).data,
}
